/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { ReactElement, useMemo } from 'react';

import { Layout } from '@components/atoms';
import { useReduxForm } from '@hooks/useReduxForm';
import _ from 'lodash';

function B2CAdditionalSurvey(): ReactElement {
  const { setFormData, formData } = useReduxForm('survey');
  const questions = useMemo(
    () => [
      {
        id: 'a-s-pl',
        answers: [
          {
            label: '감기에 자주 걸리는 편이에요',
            value: { 표: 1.2, 리: 0.8 },
          },
          {
            label: '감기에 잘 걸리지 않는 편이에요',
            value: { 표: 0.8, 리: 1.2 },
          },
        ],
      },
      {
        id: 'a-s-hy',
        answers: [
          {
            label: '몸이 찬 편이에요',
            value: { 한: 1.2, 열: 0.8 },
          },
          {
            label: '몸에 열이 많은 편이에요',
            value: { 한: 0.8, 열: 1.2 },
          },
        ],
      },
      {
        id: 'a-s-hs',
        answers: [
          {
            label: '몸이 허약하고 피로감을 자주 느끼는 편이에요',
            value: { 허: 1.2, 실: 0.8 },
          },
          {
            label: `건강한 편이지만 스트레스 받거나
  과로하면 피로감을 느껴요`,
            value: { 허: 0.8, 실: 1.2 },
          },
        ],
      },
    ],
    [],
  );
  return (
    <Layout yzTypeLayout="SURVEY">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          paddingTop: '25px',
          paddingBottom: '20px',
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <span
            style={{
              fontSize: '24px',
              lineHeight: '1.2em',
              color: '#1d1c1d',
              letterSpacing: '-0.24px',
              fontWeight: 700,
              whiteSpace: 'pre-wrap',
            }}
          >
            {`평소 내 몸에 해당하는 특징을
선택해 주세요.`}
          </span>
        </div>
        <div
          style={{
            marginTop: '27px',
            display: 'flex',
            flexDirection: 'column',
            rowGap: '35px',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            width: '100%',
          }}
        >
          {questions.map((question, idx) => (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                rowGap: '10px',
                width: '100%',
              }}
            >
              <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" fill="#2B8FFF" r="14" />
                <text
                  dominantBaseline="middle"
                  dy="2"
                  fill="white"
                  fontFamily="Arial, sans-serif"
                  fontSize="20"
                  textAnchor="middle"
                  x="50%"
                  y="50%"
                >
                  {idx + 1}
                </text>
              </svg>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  rowGap: '6px',
                  width: '100%',
                }}
              >
                {question.answers.map((q) => (
                  <button
                    onClick={() => {
                      setFormData({ ...formData, [question.id]: q.value });
                    }}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      border: _.isEqual(formData?.[question.id], q.value) ? '#C2D5EB' : '1px solid #e5e5e5',
                      background: _.isEqual(formData?.[question.id], q.value) ? '#D4E8FF' : '#ffffff',
                      borderRadius: '20px',
                      flexShrink: 0,
                      whiteSpace: 'pre-wrap',
                      width: '100%',
                      height: '55px',
                    }}
                    type="button"
                  >
                    <span
                      style={{
                        marginTop: '3px',
                        fontSize: '15px',
                        lineHeight: '1.2',
                        letterSpacing: '-0.15px',
                        color: '#1d1c1d',
                      }}
                    >
                      {q.label}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default B2CAdditionalSurvey;
